module.exports = __webpack_public_path__ + "media/images/b2b_admin/lines_shortcut_icon-f1c9bbdf0670e33c50ad2e5269191a75.svg";